import { MinimizeIcon } from './minimize-chat-button.styled';

export const MinimizeChatButton = ({ onClick }: MinimizeChatButtonProps): JSX.Element => {
  return (
    <MinimizeIcon onClick={ onClick } />
  );
};
